<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-labsample size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Lab Sample</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-labsample" centered title="New Labsample" title-class="font-18" hide-footer>
          <form @submit.prevent="addLabsample">
              <div class="form-group mb-2">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-labsample')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-labsample" centered title="Edit Labsample" title-class="font-14" hide-footer>
          <form @submit.prevent="editLabsample">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-labsample')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-labsample" centered title="Delete  Labsample" title-class="font-18" hide-footer>
          <form @submit.prevent="removeLabsample">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Labsample : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-labsample')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { labsampleMethods, labsampleComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Lab Samples",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Lab Samples",
        items: [ {text: "Dashboard",to: "/",}, {text: "Lab Samples",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
      };
    },
    computed: {
      ...labsampleComputed,
      List() { return this.labsamples.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.labsamples.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.labsamples.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchLabsamples();
      this.TotalRows = this.labsamples.length;
      this.isBusy=false;
    },
    methods: {
      ...labsampleMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('edit-labsample')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-labsample')
      },
      async addLabsample() { 
        let formData = new FormData();
        formData.append("name", this.name);
        let url = "/addlabsample";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchLabsamples();
            this.$bvModal.hide('new-labsample');
            this.name="";
        }
        });
      },
      async editLabsample(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/updatelabsample";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLabsamples();
          this.$bvModal.hide('edit-labsample');
          this.name="";
        }
      });
      },
      async removeLabsample() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removelabsample";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLabsamples();
          this.$bvModal.hide('delete-labsample');
        }
      });
      },
    },
  };
  </script>